import React, { useState } from 'react';
import './Assets.css';
import Footer from '../unAuth/Components/footer';

// Import company logos
import oreillyAutoPartsLogo from '../assets/Oreilly_BW_PH.png';
import sherwinWilliamsLogo from '../assets/Sherwinwilliams_BW_PH.png';
import starbucksLogo from '../assets/Starbucks_BW_P.png';
import verizonLogo from '../assets/Verizon_BW_PH2.png';
import dollarTreeLogo from '../assets/Dollartree_BW_PH.png';
import cvsLogo from '../assets/cvs_bw_PH.png';
import walmartLogo from '../assets/walmart_bw_PH (1).png';
import homeDepotLogo from '../assets/Homedepot_bw_PH.png';
import autoZoneLogo from '../assets/Autozone_bw_PH2.png';


function Properties({ onLearnMore }) {
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  
  const tenantLogos = [
    { logo: oreillyAutoPartsLogo, name: 'Oreilly Auto Parts', alt: 'Oreilly Auto Parts Logo' },
    { logo: sherwinWilliamsLogo, name: 'Sherwin Williams', alt: 'Sherwin Williams Logo' },
    { logo: starbucksLogo, name: 'Starbucks', alt: 'Starbucks Logo' },
    { logo: verizonLogo, name: 'Verizon', alt: 'Verizon Logo' },
    { logo: dollarTreeLogo, name: 'Dollar Tree', alt: 'Dollar Tree Logo' },
    { logo: cvsLogo, name: 'CVS', alt: 'CVS Logo' },
    { logo: walmartLogo, name: 'Walmart', alt: 'Walmart Logo' },
    { logo: homeDepotLogo, name: 'Home Depot', alt: 'Home Depot Logo' },
    { logo: autoZoneLogo, name: 'Auto Zone', alt: 'Auto Zone Logo' }
  ];

  const nextLogo = () => {
    setCurrentLogoIndex((prev) => {
      const nextIndex = prev + 3;
      return nextIndex >= tenantLogos.length ? 0 : nextIndex;
    });
  };

  const prevLogo = () => {
    setCurrentLogoIndex((prev) => {
      const prevIndex = prev - 3;
      return prevIndex < 0 ? Math.max(0, tenantLogos.length - 3) : prevIndex;
    });
  };

  // Touch handlers for swipe functionality
  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextLogo();
    } else if (isRightSwipe) {
      prevLogo();
    }
  };

  return (
    <div className="properties-page-wrapper">
      <div className="properties-page container">
        
        {/* INTRO SECTION */}
        <section className="intro-section">
          <div className="intro-container">
            <h1 className="intro-title">
              Institutional-Grade NN/NNN Real Estate
            </h1>
            <p className="intro-subtitle">
              Single-tenant properties with national-credit tenants and long-term leases — built for durable cash flow
            </p>
          </div>
        </section>



        {/* STRATEGY SECTION */}
        <section className="strategy-section" aria-labelledby="strategy-title">
          <h2 id="strategy-title" className="section-title">Investment Strategy</h2>
          <div className="strategy-grid">
            <div className="strategy-column">
              <h3 className="strategy-column-title">What We Buy</h3>
              <p className="strategy-column-body">
                NN/NNN single-tenant retail with investment-grade or national brands in durable markets across the U.S
              </p>
            </div>
            <div className="strategy-column">
              <h3 className="strategy-column-title">Why It Works</h3>
              <p className="strategy-column-body">
                Lower operating overhead, predictable rents, and scale potential across diversified locations
              </p>
            </div>
          </div>
        </section>

        {/* TARGET ECONOMICS SECTION */}
        <section className="target-economics-section" aria-labelledby="target-economics-title">
          <h2 id="target-economics-title" className="section-title">Target Economics</h2>
          <div className="economics-grid">
            <div className="economics-card">
              <h4 className="economics-label">Minimum Investment</h4>
              <p className="economics-value">$100,000</p>
            </div>
            <div className="economics-card">
              <h4 className="economics-label">Projected Term</h4>
              <p className="economics-value">3–5 years</p>
            </div>
            <div className="economics-card">
              <h4 className="economics-label">Projected Cash-on-Cash</h4>
              <p className="economics-value">6–8%</p>
            </div>
            <div className="economics-card">
              <h4 className="economics-label">Projected Annual Return</h4>
              <p className="economics-value">15–18%</p>
            </div>
            <div className="economics-card">
              <h4 className="economics-label">Leverage</h4>
              <p className="economics-value">40–60% LTV</p>
            </div>
            <div className="economics-card">
              <h4 className="economics-label">Distributions</h4>
              <p className="economics-value">Monthly</p>
            </div>
          </div>
          <div className="economics-disclaimer">
            <p>Projections are targets, not guarantees. Actual results may vary. See offering documents</p>
          </div>
        </section>

        {/* TENANT QUALITY SECTION */}
        <section className="tenant-quality-section" aria-labelledby="tenant-quality-title">
          <h2 id="tenant-quality-title" className="section-title">National-Credit Counterparties</h2>
          <p className="tenant-quality-subtitle">
            Representative brands include dollar stores, auto parts, QSR, paint, telecommunications, retail, and home improvement categories (e.g., Dollar Tree, CVS, O'Reilly Auto Parts, Auto Zone, Starbucks, Sherwin Williams, Verizon, Walmart, Home Depot)
          </p>
          
          {/* Desktop Grid Layout */}
          <div className="tenant-logos-grid desktop-logos">
            {tenantLogos.map((tenant, index) => (
              <div key={index} className="tenant-logo-item">
                <div className="tenant-logo-container">
                  <img 
                    src={tenant.logo} 
                    alt={tenant.alt}
                    className="tenant-logo-image"
                  />
                </div>
                <p className="tenant-logo-caption">{tenant.name}</p>
              </div>
            ))}
          </div>

          {/* Mobile Carousel Layout */}
          <div className="tenant-logos-carousel mobile-logos">
            <div 
              className="carousel-container"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div className="carousel-content">
                {tenantLogos.slice(currentLogoIndex, currentLogoIndex + 3).map((tenant, index) => (
                  <div key={currentLogoIndex + index} className="tenant-logo-item">
                    <div className="tenant-logo-container">
                      <img 
                        src={tenant.logo} 
                        alt={tenant.alt}
                        className="tenant-logo-image"
                      />
                    </div>
                    <p className="tenant-logo-caption">{tenant.name}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="carousel-dots">
              {Array.from({ length: Math.ceil(tenantLogos.length / 3) }, (_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${Math.floor(currentLogoIndex / 3) === index ? 'active' : ''}`}
                  onClick={() => setCurrentLogoIndex(index * 3)}
                  aria-label={`Go to logos ${index * 3 + 1}-${Math.min((index + 1) * 3, tenantLogos.length)}`}
                />
              ))}
            </div>
          </div>
          
          <div className="tenant-disclaimer">
            <p>Logos are representative only and do not imply endorsement</p>
          </div>
        </section>

        {/* FOOTPRINT SECTION */}
        <section className="footprint-section" aria-labelledby="footprint-title">
          <h2 id="footprint-title" className="section-title">Nationwide Diversification</h2>
          <p className="footprint-subtitle">
            Properties across ~20 states with emphasis on long-term fundamentals and lower weather-risk profiles
          </p>
          <div className="states-list">
            <div className="states-column">
              <h4>Primary Markets</h4>
              <ul>
                <li>Texas</li>
                <li>Florida</li>
                <li>North Carolina</li>
                <li>South Carolina</li>
                <li>Georgia</li>
                <li>Tennessee</li>
                <li>Alabama</li>
                <li>Mississippi</li>
                <li>Louisiana</li>
                <li>Arkansas</li>
              </ul>
            </div>
            <div className="states-column">
              <h4>Secondary Markets</h4>
              <ul>
                <li>Virginia</li>
                <li>Kentucky</li>
                <li>Indiana</li>
                <li>Ohio</li>
                <li>Pennsylvania</li>
                <li>New York</li>
                <li>New Jersey</li>
                <li>Connecticut</li>
                <li>Massachusetts</li>
                <li>New Hampshire</li>
              </ul>
            </div>
          </div>
        </section>

        {/* EXIT STRATEGY SECTION */}
        <section className="exit-strategy-section" aria-labelledby="exit-strategy-title">
          <h2 id="exit-strategy-title" className="section-title">Exit Strategy</h2>
          <div className="exit-strategy-panel">
            <h3 className="exit-strategy-heading">Portfolio-Sale Exit</h3>
            <p className="exit-strategy-body">
              Aggregate assets and pursue a sale to institutional buyers (REITs, PE firms, insurers, pensions, endowments)
            </p>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="cta-section" aria-labelledby="cta-title">
          <div className="cta-buttons">
            <button onClick={onLearnMore} className="cta-button primary">Learn More</button>
          </div>
        </section>

      </div>
      <Footer />
    </div>
  );
}

export default Properties;
